import { render, staticRenderFns } from "./HistorialSolicitud.vue?vue&type=template&id=55c703f4"
import script from "./HistorialSolicitud.vue?vue&type=script&lang=js"
export * from "./HistorialSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports